
export default {
  namespaced: true,
  state: {
    appTitle: 'Corbion Dissociation Tool'
  },
  getters: {},
  mutations: {},
  actions: {}
};
